module.exports = __webpack_public_path__ + "static/media/comment.a1ee7905.svg";